<template>
  <div class="vg-view-field">
    <div class="vg-view-field-label" :style="{width: labelWidth}">
      <label>{{ label + (labelSuffix || '') }}</label>
    </div>
    <div class="vg-view-field-value" :class="{bold: boldValue}">
      <slot v-if="this.$slots.default"></slot>
      <span v-else>{{ value }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "VgViewField",
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: null,
    },
    labelSuffix: String,
    labelWidth: String,
    boldValue: Boolean
  }
}
</script>

<style scoped>
.bold {
  font-weight: bold;
}

.vg-view-field-value {
  margin-left: 10px;
}

.vg-view-field-label {
  /*margin-bottom: 6px;*/
  /*font-size: 16px;*/
  /*font-weight: 600;*/
  color: #B4B4B4;
  line-height: 22px;
  flex-shrink: 0;
  /*font-weight: bold;*/
}

.vg-view-field-value {
  /*min-height: 20px;*/
  /*font-size: 14px;*/
  /*font-weight: 600;*/
  /*color: #333333;*/
  line-height: 20px;
}

.vg-view-field {
  padding: 8px 10px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.vg-view-field.vertical {
  align-items: flex-start;
  flex-direction: column;
}

.vg-view-field.vertical .vg-view-field-value {
  margin: 5px 0 0;
  width: 100%;
  box-sizing: border-box;
  padding: 0 5px;
}

.vg-view-field.primary .vg-view-field-value {
  color: #4BA9F6;
}

.vg-view-field.error .vg-view-field-value {
  color: #FF3434;
}

</style>